import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const About = () => {
  return (
    <Card sx={{mt: 7, mx:1}}>
      <CardContent>
        <Typography variant="h2" gutterBottom>À propos des Jeux de la CJSOI 2025</Typography>
        <Typography variant="body1" paragraph>
          Les Jeux de la Commission de la Jeunesse et des Sports de l’Océan Indien (CJSOI), créés en 1988, sont un événement multisports biennal destiné aux jeunes athlètes âgés de 14 à 17 ans issus de sept nations de l’océan Indien : les Comores, Djibouti, Madagascar, Maurice, Mayotte, La Réunion et les Seychelles. La 13e édition se tiendra aux Seychelles du 28 juillet au 10 août 2025.
        </Typography>
        <Typography variant="body1" paragraph>
          Les Jeux de la CJSOI visent à promouvoir l’amitié, les échanges culturels et la coopération régionale à travers le sport et des programmes jeunesse. L’édition 2025 comprendra 11 disciplines sportives : athlétisme, beach soccer, natation, badminton, volley-ball, judo, basketball, voile, boxe, football et haltérophilie. En parallèle des compétitions, l’événement accueillera également un forum jeunesse sur la santé et l’éducation, une assemblée des jeunes, des compétitions d’e-sport, ainsi que des échanges culturels tels que la danse, le chant et le théâtre.
        </Typography>
        <Typography variant="body1">
          Organisés sur plusieurs sites à travers Mahé, notamment le Stade Linité et le Gymnase de Victoria, les Jeux ont pour objectif de renforcer la solidarité et de mettre en valeur les talents de la jeunesse de la région. Rejoignez-nous pour célébrer cet événement dynamique et inspirant !
        </Typography>
      </CardContent>
    </Card>
  );
};

export default About;